import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor() {}

  log(...args: any[]): void {
    console.log(...args);
  }

  error(...args: any[]): void {
    console.log(...args);
  }
}
